export default __webpack_public_path__ + "static/media/biblioteca-bibliotecheNC.aa53029f.svg";